import env from '../../../environment.js';
import { getCalidadLS } from './helpers.js';

export function buildDefaultValues() {
  const ls = getCalidadLS();
  const cicloIdLS = Number(localStorage.getItem(`${env.appName}-ciclo_id`) || 0);
  const info = ls?.info_muestra || {};
  const af = ls?.analisis_fisico || {};
  const ao = ls?.analisis_oro || {};
  const as = ls?.analisis_sensorial || {};

  return {
    info_muestra: {
      id_calidad_analisis: info.id_calidad_analisis ?? '',
      id_calidad_analisis_fisico: info.id_calidad_analisis_fisico ?? '',
      id_tipo_analisis_fisico: info.id_tipo_analisis_fisico ?? '',
      id_tipo_proceso: info.id_tipo_proceso ?? '',
      id_tipo_muestra: info.id_tipo_muestra ?? '',
      id_tipo_cafe: info.id_tipo_cafe ?? '',
      peso_asociado: info.peso_asociado ?? '',
      id_calidad_analisis_sensorial: info.id_calidad_analisis_sensorial ?? '',
      id_cuenta: info.id_cuenta ?? '',
      id_acopio: info.id_acopio ?? '',
      id_recoleccion_acopio: info.id_recoleccion_acopio ?? info.id_lote ?? '',
      id_muestra: info.id_muestra,
      id_tipo_analisis: info.id_tipo_analisis ?? info.tipo_analisis ?? '',
      analisis_por_entrega: info.analisis_por_entrega ?? '',
      id_ciclo: info.id_ciclo ?? (cicloIdLS > 0 ? cicloIdLS : ''),
      nombre_proveedor: info.nombre_proveedor ?? '',
      region_proveedor: info.region_proveedor ?? '',
      notas_adicionales: info.notas_adicionales ?? '',
      observaciones: info.observaciones ?? '',
      id_municipio: info.id_municipio ?? '',
      id_localidad: info.id_localidad ?? '',
      uuid_calidad_analisis: info.uuid_calidad_analisis ?? '',
      fecha: info.fecha ?? '',
    },
    analisis_fisico: {
      pergamino_peso_muestra_pergamino: af.pergamino_peso_muestra_pergamino ?? '',
      pergamino_peso_muestra_oro: af.pergamino_peso_muestra_oro ?? '',
      pergamino_peso_mancha: af.pergamino_peso_mancha ?? '',
      pergamino_densidad: af.pergamino_densidad ?? '',
      pergamino_humedad: af.pergamino_humedad ?? '',
      pergamino_actividad_agua: af.pergamino_actividad_agua ?? '',
      olor_muestra: af.olor_muestra ?? '',
      id_color_muestra: af.id_color_muestra ?? ao.id_color_muestra ?? '',
      uuid_calidad_analisis_fisico: af.uuid_calidad_analisis_fisico ?? af.uuid_tipo_analisis_fisico ?? '',
    },
    analisis_oro: {
      pergamino_peso_muestra_oro_2: ao.pergamino_peso_muestra_oro_2 ?? af.pergamino_peso_muestra_oro ?? '',
      total_defectos_gramos: ao.total_defectos_gramos ?? '',
      perdida_procesamiento_por: ao.perdida_procesamiento_por ?? '',
      peso_cafe_limpio_grs: ao.peso_cafe_limpio_grs ?? '',
      rendimiento_exportable_por: ao.rendimiento_exportable_por ?? '',
      zarandas: Array.isArray(ao.zarandas) && ao.zarandas.length > 0
        ? ao.zarandas
        : [
            { id_calidad_analisis_fisicos_zaranda: 0, id_zaranda: "6", valor: '', eliminar: 0 },
            { id_calidad_analisis_fisicos_zaranda: 0, id_zaranda: "7", valor: '', eliminar: 0 },
          ],
      defectos_primarios: Array.isArray(ao.defectos_primarios) && ao.defectos_primarios.length > 0
        ? ao.defectos_primarios
        : [{ id_calidad_analisis_fisicos_defecto: 0, id_tipo_mancha: 0, no_granos: '', defectos: '', eliminar: 0 }],
      defectos_secundarios: Array.isArray(ao.defectos_secundarios) && ao.defectos_secundarios.length > 0
        ? ao.defectos_secundarios
        : [{ id_calidad_analisis_fisicos_defecto: 0, id_tipo_mancha: 0, no_granos: '', defectos: '', eliminar: 0 }],
    },
    analisis_sensorial: {
      id_calidad_analisis_sensorial: as.id_calidad_analisis_sensorial ?? info.id_calidad_analisis_sensorial ?? '',
      perfil_taza: as.perfil_taza ?? '',
      fragancia_aroma: as.fragancia_aroma ?? '',
      fragancia_aroma_desc: as.fragancia_aroma_desc ?? '',
      sabor: as.sabor ?? '',
      sabor_desc: as.sabor_desc ?? '',
      sabor_residual: as.sabor_residual ?? '',
      sabor_residual_desc: as.sabor_residual_desc ?? '',
      acidez: as.acidez ?? '',
      acidez_desc: as.acidez_desc ?? '',
      cuerpo: as.cuerpo ?? '',
      cuerpo_desc: as.cuerpo_desc ?? '',
      balance: as.balance ?? '',
      balance_desc: as.balance_desc ?? '',
      uniformidad: as.uniformidad ?? '',
      uniformidad_desc: as.uniformidad_desc ?? '',
      taza_limpia: as.taza_limpia ?? '',
      taza_limpia_desc: as.taza_limpia_desc ?? '',
      dulzor: as.dulzor ?? '',
      dulzor_desc: as.dulzor_desc ?? '',
      puntaje_calculado: as.puntaje_calculado ?? '',
      puntaje_manual: as.puntaje_manual ?? '',
      defectos_no_tazas: as.defectos_no_tazas ?? '',
      defectos_intensidad: as.defectos_intensidad ?? '',
      catador: as.catador ?? '',
      catador_desc: as.catador_desc ?? '',
      uuid_calidad_analisis_sensorial: as.uuid_calidad_analisis_sensorial ?? '',
    },
  };
}